<template>
  <div class="group">
    <h5 class="group__title">{{ group.name }}</h5>
    <section
      v-for="topic in group.content"
      :key="`group-${topic.name}`"
      class="group__topic-wrapper"
    >
      <Topic
        :isUser="isUser"
        :topic="topic"
        :topicProgress="getTopicProgress(topic)"
        :progress="progress"
        :type="topicType"
        :parentId="courseId"
      />
    </section>
  </div>
</template>

<script>
import Topic from '@/components/content/Topic.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'Group',
  components: {
    Topic,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    isUser: {
      type: Boolean,
      required: true,
    },
    progress: {
      type: [Object, String],
      required: false,
    },
    currentVideos: {
      type: Array,
      required: true,
    },
    currentQuizzes: {
      type: Array,
      required: true,
    },
    currentExercises: {
      type: Array,
      required: true,
    },
    currentLabs: {
      type: Array,
      required: true,
    },
    currentIFrames: {
      type: Array,
      required: true,
    },
    courseId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      topicType: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.COURSE,
    }
  },
  methods: {
    getCurrentContent({ type, uuid }) {
      switch (type) {
        case 'video':
          return this.currentVideos.find(video => video.id === uuid)
        case 'quiz':
          return this.currentQuizzes.find(quiz => quiz.id === uuid)
        case 'exercise':
          return this.currentExercises.find(exercise => exercise.id === uuid)
        case 'lab':
          return this.currentLabs.find(lab => lab.id === uuid)
        case 'iframe':
          return this.currentIFrames.find(iframe => iframe.id === uuid)
        default:
          return { user_status: CONSTANTS.CONTENT_USER_STATUS.UNSTARTED }
      }
    },
    getTopicProgress(topic) {
      const progress = { total: topic.content.length, completed: 0 }
      if (this.isUser) {
        topic.content.map(level => {
          const { content_type: type, uuid } = level
          const current = this.getCurrentContent({ type, uuid })
          if (!current) return
          const { user_status, is_trackable } = current
          if (!user_status) return
          const { FINISHED, VISITED, STARTED } = CONSTANTS.CONTENT_USER_STATUS
          const { LAB, IFRAME, SLIDES, EXERCISE } = CONSTANTS.CONTENT_TYPES
          const isVisitedOrFinished = [FINISHED, VISITED].includes(user_status)
          const isNonCTFLabStarted =
            !is_trackable && type === LAB && user_status === STARTED
          const isSlideIframeStarted =
            [SLIDES, IFRAME].includes(type) && user_status === STARTED
          const isExerciseStarted =
            [EXERCISE].includes(type) && user_status === STARTED
          if (
            isVisitedOrFinished ||
            isNonCTFLabStarted ||
            isSlideIframeStarted ||
            isExerciseStarted
          )
            progress.completed += 1
        })
      }
      return progress
    },
  },
}
</script>

<style lang="scss" scoped>
.group {
  &__title {
    font-size: 2rem;
    color: var(--white);
    margin-bottom: 30px;
    font-family: var(--font-regular);
  }
  &__topic-wrapper {
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }
  &__topic-quiz-wrapper {
    margin: 0 0 0 auto;
  }
}
</style>
